<template>
  <div></div>
</template>
<script>
export default {
  name: 'BlankPage'
}
</script>
